export const normalizeId = (value) => String(value ?? "");

export const getProjectId = (item) => item?.ProjectID ?? item?.ID ?? null;

export const getProjectStatus = (item) => item?.ProjectStatus || item?.JobStatus || "N/A";

export const idsMatch = (left, right) => normalizeId(left) === normalizeId(right);
